import React from "react";
import PropTypes from "prop-types";
import { Field, fieldClass } from "../formLayout";
import PainIntensityScale from "../shared/PainIntensityScale";
import { CLINICAL_VITALS_FIELDS } from "./clinicalVitals";

/**
 * Nurse Evaluation pattern — shared across all nurse notes that capture vitals.
 * Six vitals in one row + Pain Intensity Scale (0–10) button group.
 */
const ClinicalVitalsFields = ({
  values,
  canEdit = false,
  onChange,
  showWeight = true,
}) => {
  const setField = (key, next) => {
    onChange?.(key, next);
  };

  const fields = showWeight
    ? CLINICAL_VITALS_FIELDS
    : CLINICAL_VITALS_FIELDS.filter((f) => f.key !== "vitalsWeight");

  return (
    <div className="space-y-5">
      <div
        className={`grid grid-cols-2 sm:grid-cols-3 ${
          showWeight ? "lg:grid-cols-6" : "lg:grid-cols-5"
        } gap-x-4 gap-y-3`}
      >
        {fields.map(({ key, label, placeholder }) => (
          <Field key={key} label={label}>
            <input
              type="text"
              className={`${fieldClass} text-center tabular-nums`}
              value={values?.[key] ?? ""}
              disabled={!canEdit}
              placeholder={placeholder}
              onChange={(e) => setField(key, e.target.value)}
            />
          </Field>
        ))}
      </div>

      <PainIntensityScale
        value={values?.painLevel}
        canEdit={canEdit}
        onChange={(next) => setField("painLevel", next)}
        name="painLevel"
      />
    </div>
  );
};

ClinicalVitalsFields.propTypes = {
  values: PropTypes.object,
  canEdit: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  showWeight: PropTypes.bool,
};

export default ClinicalVitalsFields;
